<template>
  <div>
      <van-row class="user-links">
        <van-cell-group>
         <van-image
            round
            width="5rem"
            height="5rem"
             :src="headimgRul"
          />
        </van-cell-group>
      
      </van-row>

      <van-cell-group>
        <van-cell icon="points" title="个人信息" is-link url="/ysj/userInfo" />
        <van-cell icon="gold-coin-o" title="我的课程" @click="tomyKecheng" is-link />
        <van-cell icon="gift-o" title="我的活动" @click="tomyFile" is-link />
      </van-cell-group>
    </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup ,Dialog} from 'vant';
  export default {
    data() {
     return{
      nickname : null,
      isVoice : null,
      userId:null,
      phone:null,
      headimgRul:null,
      status:null,
     };
    },
    created() {
     this.nickname = sessionStorage.getItem('nickname');
     this.headimgRul = sessionStorage.getItem('headimgRul');
     this.status = sessionStorage.getItem('status');
  },
   methods: {
      tomyKecheng:function(){
        if(status == 0){
           Dialog.alert({
                            message: '您还没有购买任何课程',
                          }).then(() => {
                            // on close
                          });
        } else {
             this.$router.push({ path:'/ysj/courseInfo'  })
        }
      },
      tomyFile:function(){
         this.$router.push({ path:'/ysj/myFile'  })
      }
   }
  }
</script>

<style lang="less">
.user {
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 5px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    
    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
.aaa{
  border:1px solid red;
}
</style>